<template>
  <el-dialog
    :visible.sync="DialogShow"
    @closed="closeDialog"
    @open="openDialog"
    append-to-body
    width="85%"
    custom-class="import-dialog"
    top="5vh"
    :close-on-click-modal="false"
  >
    <div slot="title" class="dialog-title">
      <span class="title-line"></span>
      <span class="title-text">{{ title }}</span>
    </div>
    <el-form
      :model="submitFormData"
      :rules="rules"
      ref="form"
      label-width="130px"
    >
      <el-steps :active="active">
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
      </el-steps>

      <el-tabs tab-position="bottom" v-model="editableTabsValue">
        <el-tab-pane name="first">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="签证名称" prop="visaName">
                <el-input
                  placeholder="请输入签证名称"
                  v-model="submitFormData.visaName"
                  size="small"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签证描述" prop="visaDescription">
                <el-input
                  placeholder="请输入签证描述"
                  v-model="submitFormData.visaDescription"
                  size="small"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="国家" prop="countryBid">
                <el-select
                  v-model="submitFormData.countryBid"
                  placeholder="请选择国家"
                  size="small"
                  @change="countryChange(submitFormData.countryBid)"
                >
                  <el-option
                    :label="item.countryName"
                    :value="item.countryBid"
                    v-for="item in countryList"
                    :key="item.countryBid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签证分类" prop="categoryBid">
                <el-select
                  v-model="submitFormData.categoryBid"
                  placeholder="请选择签证分类"
                  size="small"
                >
                  <el-option
                    :label="item.categoryName"
                    :value="item.categoryBid"
                    v-for="item in visaTypeList"
                    :key="item.categoryBid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="领区"
                prop="consularDistrictBid"
                v-if="visaBid"
              >
                <el-select
                  v-model="submitFormData.consularDistrictBid"
                  placeholder="请选择领区"
                  size="small"
                >
                  <el-option
                    :label="item.flavorValue"
                    :value="item.flavorId"
                    v-for="item in consularList"
                    :key="item.flavorId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="领区"
                prop="consularDistrictBids"
                v-if="!visaBid"
              >
                <el-select
                  v-model="submitFormData.consularDistrictBids"
                  placeholder="请选择领区"
                  size="small"
                  multiple
                >
                  <el-option
                    :label="item.flavorValue"
                    :value="item.flavorId"
                    v-for="item in consularList"
                    :key="item.flavorId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入境次数" prop="entriesBid">
                <el-select
                  v-model="submitFormData.entriesBid"
                  placeholder="请选择入境次数"
                  size="small"
                >
                  <el-option
                    :label="item.flavorValue"
                    :value="item.flavorId"
                    v-for="item in entriesList"
                    :key="item.flavorId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="价格" prop="price">
                <el-input
                  v-model.number="submitFormData.price"
                  placeholder="请输入价格"
                  size="small"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="有效期限" prop="validPeriod">
                <el-input
                  placeholder="请输入有效期限"
                  v-model="submitFormData.validPeriod"
                  size="small"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="停留时长" prop="stayDuration">
                <el-input
                  placeholder="请输入停留时长"
                  v-model="submitFormData.stayDuration"
                  size="small"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="价格明细" prop="priceDetail">
                <el-input
                  placeholder="请输入价格明细"
                  v-model="submitFormData.priceDetail"
                  size="small"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="办理周期" prop="processingPeriodDays">
                <el-input
                  placeholder="请输入办理周期"
                  v-model="submitFormData.processingPeriodDays"
                  size="small"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预计出签周期" prop="visaCheckoutDays">
                <el-input
                  placeholder="请输入预计出签周期"
                  v-model="submitFormData.visaCheckoutDays"
                  size="small"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出签率" prop="checkoutRate">
                <el-input
                  placeholder="请输入出签率"
                  v-model.number="submitFormData.checkoutRate"
                  size="small"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否关联申请表" prop="hasElectronicForm">
                <el-select
                  v-model="submitFormData.hasElectronicForm"
                  placeholder="请选择是否关联申请表"
                  size="small"
                >
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请表列表" prop="electronicFormBid">
                <el-select
                  v-model="submitFormData.electronicFormBid"
                  placeholder="请选择申请表列表"
                  size="small"
                  clearable
                >
                  <el-option
                    :label="item.value"
                    :value="item.key"
                    v-for="item in electronList"
                    :key="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签证状态" prop="state">
                <el-select
                  v-model="submitFormData.state"
                  placeholder="请选择签证状态"
                  size="small"
                >
                  <el-option label="上架" :value="0"></el-option>
                  <el-option label="下架" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签证条约" prop="termBid">
                <el-select
                  v-model="submitFormData.termBid"
                  placeholder="请选择签证条约"
                  size="small"
                  clearable
                >
                  <el-option
                    :label="item.value"
                    :value="item.key"
                    v-for="item in termList"
                    :key="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签证图例" prop="visaExamplePictureBid">
                <el-upload
                  class="avatar-uploader"
                  :action="`${uploadfileUrl}/fileManager/uploadPicture`"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :on-error="handleAvatarError"
                  :before-remove="handleAvatarRemove"
                  :on-change="uploadChange"
                  :before-upload="beforeFileUpload"
                  name="file"
                  :headers="{ token }"
                >
                  <img
                    v-if="visaPictureUrl"
                    :src="visaPictureUrl"
                    class="avatar"
                    @click="visaPictureClick"
                  />
                  <el-button
                    v-else
                    size="small"
                    type="primary"
                    @click="visaPictureClick"
                    >去上传</el-button
                  >
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="from-btn-wrap">
            <el-button
              type="primary"
              @click="handelClickFirstSubmit"
              size="small"
            >
              下一步
            </el-button>
            <el-button
              type="primary"
              plain
              size="small"
              @click="handelClickCancel"
              >取消</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <div
            v-for="(domain, index) in submitFormData.identityList"
            :key="index"
            class="border-wrap"
          >
            <el-form-item
              :label="'选择身份'"
              :prop="'identityList.' + index + '.applicantIdentityBid'"
              :rules="{
                required: true,
                message: '请选择身份',
                trigger: 'change',
              }"
            >
              <el-select
                v-model="domain.applicantIdentityBid"
                placeholder="请选择身份"
                size="small"
                class="sort-inp"
              >
                <el-option
                  :label="item.value"
                  :value="item.key"
                  v-for="item in applicantList"
                  :key="item.key"
                ></el-option>
              </el-select>
              <el-button
                icon="el-icon-minus"
                size="small"
                v-if="inx != 0"
                @click="delIdentity(index)"
              ></el-button>
              <!-- <el-input v-model="domain.applicantIdentityBid"></el-input> -->
            </el-form-item>
            <el-form-item
              label="电子资料"
              :prop="'identityList.' + index + '.electronicInformationBids'"
              :rules="{
                required: true,
                message: '请选择电子资料',
                trigger: 'change',
              }"
            >
              <el-checkbox-group v-model="domain.electronicInformationBids">
                <el-checkbox
                  v-for="(item, inx) of informationList"
                  :key="inx"
                  :label="item.key"
                  name="type"
                  >{{ item.value }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="邮寄资料"
              :prop="'identityList.' + index + '.mailInformationBids'"
              :rules="{
                required: false,
                message: '请选择邮寄资料',
                trigger: 'change',
              }"
            >
              <el-checkbox-group v-model="domain.mailInformationBids">
                <el-checkbox
                  v-for="(item, inx) of informationList"
                  :key="inx"
                  :label="item.key"
                  name="type"
                  >{{ item.value }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class="add-identity">
            <el-button type="primary" @click="addIdentityClick" size="small">
              添加身份
            </el-button>
          </div>
          <div class="from-btn-wrap">
            <el-button
              type="primary"
              @click="gotoFirstSubmit(1, 'first')"
              size="small"
            >
              上一步
            </el-button>

            <el-button type="primary" plain size="small" @click="nextStepClick"
              >下一步</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane name="third">
          <div
            v-for="(formItem, index) of submitFormData.instructionList"
            :key="index"
            class="border-wrap"
          >
            <el-form-item
              label="标题"
              :prop="'instructionList.' + index + '.title'"
              :rules="{
                required: true,
                message: '请填写标题',
                trigger: 'blur',
              }"
              class="instruction-desc"
            >
              <el-input
                placeholder="请输入标题"
                v-model="formItem.title"
                size="small"
                class=""
              ></el-input>
              <el-button
                icon="el-icon-plus"
                size="small"
                @click="addInstruction"
              ></el-button>
              <el-button
                icon="el-icon-minus"
                size="small"
                v-if="inx != 0"
                @click="delInstruction(index)"
              ></el-button>
            </el-form-item>
            <el-form-item
              label="标题icon"
              :prop="'instructionList.' + index + '.pictureBid'"
              :rules="{
                required: true,
                message: '请上传icon',
                trigger: 'blur',
              }"
            >
              <el-upload
                class="avatar-uploader"
                :action="`${uploadfileUrl}/fileManager/uploadPicture`"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-error="handleAvatarError"
                :before-remove="handleAvatarRemove"
                :on-change="uploadChange"
                :before-upload="beforeFileUpload"
                name="file"
                :headers="{ token }"
              >
                <img
                  v-if="formItem.pictureUrl"
                  :src="formItem.pictureUrl"
                  class="avatar"
                  @click="titlePictureClick(index)"
                />
                <el-button
                  v-else
                  size="small"
                  type="primary"
                  @click="titlePictureClick(index)"
                  >去上传</el-button
                >
              </el-upload>
            </el-form-item>
            <div v-for="(item, inx) of formItem.contentList" :key="inx">
              <el-form-item
                :label="'描述' + (inx + 1)"
                :prop="
                  'instructionList.' + index + '.contentList.' + inx + '.value'
                "
                :rules="{
                  required: true,
                  message: '请填写描述',
                  trigger: 'blur',
                }"
                class="instruction-desc"
              >
                <el-input
                  placeholder="请输入描述"
                  v-model="item.value"
                  size="small"
                ></el-input>
                <el-button
                  icon="el-icon-plus"
                  size="small"
                  @click="addTitleClick(index)"
                ></el-button>
                <el-button
                  icon="el-icon-minus"
                  size="small"
                  v-if="inx != 0"
                  @click="subTitleClick(index, inx)"
                ></el-button>
              </el-form-item>
            </div>
          </div>
          <div class="from-btn-wrap">
            <el-button
              type="primary"
              @click="gotoFirstSubmit(2, 'second')"
              size="small"
            >
              上一步
            </el-button>

            <el-button type="primary" @click="handelClickSubmit" size="small">{{
              upDataMsg
            }}</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-dialog>
</template>

<script>
import { clone } from '@/utils/utils';
import { countryGetAll } from '@/api/country';
import {
  getAllConsularDistrict,
  getByTypeEntries,
  visaUpdate,
  visaCreate,
  visaGetDetailByBid,
  getAllElectronicForms,
} from '@/api/visa';
import { getAllTerms } from '@/api/term';
import { getByCountryBid } from '@/api/visaCategory';
import { visaApplicantGetAllIdentity } from '@/api/applicantIdentity';
import { getAllInformation } from '@/api/applicantInformation';
const defaultUpdataObj = {
  visaName: '',
  visaDescription: '',
  countryBid: '',
  categoryBid: '',
  consularDistrictBid: '',
  consularDistrictBids: [],
  entriesBid: '',
  price: '',
  validPeriod: '',
  stayDuration: '',
  priceDetail: '',
  processingPeriodDays: '',
  visaCheckoutDays: '',
  checkoutRate: '',
  state: '',
  visaExamplePictureBid: '',
  hasElectronicForm: '',
  electronicFormBid: '',
  termBid: '',
  identityList: [
    {
      applicantIdentityBid: '',
      electronicInformationBids: [],
      mailInformationBids: [],
    },
  ],
  instructionList: [
    {
      contentList: [
        {
          value: '',
        },
      ],
      pictureBid: '',
      pictureUrl: '',
      title: '',
    },
  ],
};
export default {
  data() {
    return {
      token: '',
      editableTabsValue: 'first',
      active: 1,
      upDataMsg: '保存',
      submitFormData: clone(defaultUpdataObj), //
      rules: {
        visaName: [
          { required: true, message: '请输入签证名称', trigger: 'change' },
        ],
        countryBid: [
          { required: true, message: '请选择所属国家', trigger: 'change' },
        ],
        categoryBid: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
        consularDistrictBid: [
          { required: true, message: '请选择领区', trigger: 'change' },
        ],
        consularDistrictBids: [
          { required: true, message: '请选择领区', trigger: 'change' },
        ],
        entriesBid: [
          { required: true, message: '请选择入境次数', trigger: 'change' },
        ],
        state: [
          { required: true, message: '请选择签证状态', trigger: 'change' },
        ],
        visaExamplePictureBid: [
          { required: true, message: '请上传文件', trigger: 'blur' },
        ],
        checkoutRate: [
          { required: true, message: '请输入出签率', trigger: 'blur' },
          { type: 'number', message: '出签率必须为数字值' },
        ],
        visaCheckoutDays: [
          { required: true, message: '请输入签证出签周期', trigger: 'blur' },
        ],
        processingPeriodDays: [
          { required: true, message: '请输入办理周期', trigger: 'blur' },
        ],
        priceDetail: [
          { required: true, message: '请输入价格明细', trigger: 'blur' },
        ],
        stayDuration: [
          { required: true, message: '请输入停留时长', trigger: 'blur' },
        ],
        validPeriod: [
          { required: true, message: '请输入有效期限', trigger: 'blur' },
        ],
        price: [
          { required: true, message: '价格不能为空' },
          { type: 'number', message: '价格必须为数字值' },
        ],
        hasElectronicForm: [
          {
            required: true,
            message: '请选择是否关联申请表',
            trigger: 'change',
          },
        ],
        electronicFormBid: [
          { required: false, message: '请选择申请表列表', trigger: 'change' },
        ],
      }, //  hasElectronicForm: '',
      // electronicFormBid: '',
      DialogShow: false,
      countryList: [],
      visaTypeList: [],
      consularList: [],
      entriesList: [],
      applicantList: [],
      visaPictureUrl: '',
      imgType: '',
      informationList: [],
      setItemIconInx: null,
      electronList: [],
      termList: [],
    };
  },
  props: {
    title: {
      type: String,
      default: function () {
        return '';
      },
    },
    visaBid: {
      type: String,
      default: '',
    },
  },
  methods: {
    openDialog() {
      this.token = localStorage.getItem('token');
      this.getInformationTypeFunc();
      if (this.visaBid) {
        visaGetDetailByBid(this.visaBid).then((res) => {
          console.log(res);
          if (res.code == 200) {
            Object.assign(this.submitFormData, res.data);
            this.visaPictureUrl = res.data.visaExamplePictureUrl;
            this.countryChange(this.submitFormData.countryBid);
          }
        });
      }
    },
    //国家 领区
    getInformationTypeFunc() {
      countryGetAll().then((res) => {
        if (res.code == 200) {
          this.countryList = res.data;
        }
      });
      getAllConsularDistrict().then((res) => {
        if (res.code == 200) {
          this.consularList = res.data;
        }
      });
      getByTypeEntries().then((res) => {
        if (res.code == 200) {
          this.entriesList = res.data;
        }
      });
      visaApplicantGetAllIdentity().then((res) => {
        if (res.code == 200) {
          this.applicantList = res.data;
        }
      });
      getAllInformation().then((res) => {
        if (res.code == 200) {
          this.informationList = res.data;
        }
      });
      getAllElectronicForms().then((res) => {
        if (res.code == 200) {
          this.electronList = res.data;
          console.log(this.electronList);
        }
      });
      getAllTerms().then((resp) => {
        if (resp.code == 200) {
          this.termList = resp.data;
        }
      });
    },
    //签证
    countryChange(id) {
      if (id) {
        getByCountryBid(id).then((res) => {
          if (res.code == 200) {
            this.visaTypeList = res.data;
          }
        });
      } else {
        this.visaTypeList = [];
      }
    },
    handelClickFirstSubmit() {
      console.log(this.submitFormData);
      let gotoNext = true;
      this.$refs.form.validateField(
        [
          'visaName',
          'countryBid',
          'categoryBid',
          'consularDistrictBid',
          'consularDistrictBids',
          'entriesBid',
          'price',
          'validPeriod',
          'stayDuration',
          'priceDetail',
          'processingPeriodDays',
          'visaCheckoutDays',
          'checkoutRate',
          'state',
          'visaExamplePictureBid',
        ],
        (valid) => {
          if (valid) {
            gotoNext = false;
          }
        }
      );
      if (gotoNext) {
        this.editableTabsValue = 'second';
        this.active = 2;
      }
    },
    handelClickSubmit() {
      if (this.upDataMsg == '保存') {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.upDataMsg = '保存中..';
            let hasElectronicForm = this.submitFormData.hasElectronicForm;
            if (hasElectronicForm == 1) {
              this.submitFormData.hasElectronicForm = true;
            } else {
              this.submitFormData.hasElectronicForm = false;
            }

            if (!this.visaBid) {
              visaCreate(this.submitFormData).then((res) => {
                if (res.code == 200) {
                  this.$msg.success('保存成功！');
                  this.$emit('upData');
                  this.closeDialog();
                }
              });
              this.upDataMsg = '保存';
            } else {
              visaUpdate(this.submitFormData).then((res) => {
                if (res.code == 200) {
                  this.$msg.success('保存成功！');
                  this.$emit('upData');
                  this.closeDialog();
                }
              });
              this.upDataMsg = '保存';
            }
          }
        });
      }
    },
    gotoFirstSubmit(active, stepName) {
      this.editableTabsValue = stepName;
      this.active = active;
    },
    addIdentityClick() {
      let dataObj = {
        applicantIdentityBid: '',
        electronicInformationBids: [],
        mailInformationBids: [],
      };
      this.submitFormData.identityList.push(dataObj);
      console.log(this.submitFormData.identityList);
    },
    nextStepClick() {
      let validArr = [];
      this.submitFormData.identityList.forEach((formItem, inx) => {
        validArr.push('identityList.' + inx + '.applicantIdentityBid');
        validArr.push('identityList.' + inx + '.electronicInformationBids');
        validArr.push('identityList.' + inx + '.mailInformationBids');
      });
      let gotoNext = true;
      this.$refs.form.validateField(validArr, (valid) => {
        if (valid) {
          gotoNext = false;
        }
      });
      if (gotoNext) {
        this.editableTabsValue = 'third';
        this.active = 3;
      }
    },
    addTitleClick(outIndex) {
      this.submitFormData.instructionList[outIndex].contentList.push({
        value: '',
      });
    },
    subTitleClick(outIndex, inIndex) {
      this.submitFormData.instructionList[outIndex].contentList.splice(
        inIndex,
        1
      );
    },

    addInstruction() {
      this.submitFormData.instructionList.push({
        contentList: [
          {
            value: '',
          },
        ],
        pictureBid: '',
        pictureUrl: '',
        title: '',
      });
    },
    delInstruction(index) {
      this.submitFormData.instructionList.splice(index, 1);
    },
    delIdentity(index) {
      this.submitFormData.identityList.splice(index, 1);
    },
    handelClickCancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.editableTabsValue = 'first';
      this.active = 1;
      this.$refs.form.resetFields();
      this.DialogShow = false;
    },
    //上传相关---------------------------------------------------------------------
    visaPictureClick() {
      this.imgType = 'visaPicture';
    },
    titlePictureClick(inx) {
      this.setItemIconInx = inx;
      this.imgType = 'titlePicture';
    },
    handleAvatarSuccess(res) {
      this.duration = 10;
      this.$msg.success('上传成功');
      this.duration = 0;
      if (this.imgType == 'visaPicture') {
        this.visaPictureUrl = res.data.fileUrl;
        this.submitFormData.visaExamplePictureBid = res.data.fileBid;
        this.$refs.form.clearValidate('visaExamplePictureBid');
      } else {
        this.submitFormData.instructionList[this.setItemIconInx].pictureBid =
          res.data.fileBid;
        this.submitFormData.instructionList[this.setItemIconInx].pictureUrl =
          res.data.fileUrl;
        // pictureBid pictureUrl
      }

      // fileBid fileUrl
    },
    handleAvatarError() {
      this.$msg.error('上传失败');
    },
    handleAvatarRemove() {
      this.$msg.error('上传失败');
    },
    uploadChange(file, fileList) {
      this.fileList = fileList;
    },
    uploadChange(file, fileList) {
      this.fileList = fileList;
    },
    isImage(fileName) {
      if (typeof fileName !== 'string') {
        return;
      }
      let name = fileName.toLowerCase();
      return name.endsWith('.png') || name.endsWith('.jpg');
    },
    beforeFileUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      let type = this.isImage(file.name);
      let fileLength = this.fileList.length;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return;
      } else if (!type) {
        // 若不符合图片类型，则让当前上传的文件去除掉即可，即从上传对列删除本次上传
        this.fileList.splice(fileLength - 1, 1);
        this.$msg.error('只允许上传jpg、png，且文件大小不能超过 10MB!');
        return;
        // this.type = false;
      } else {
        // this.type = true;
        this.$msg({
          duration: this.duration,
          message: '上传中',
          showClose: true,
        });
      }
      return isLt10M && type;
    },
  },
  computed: {
    uploadfileUrl() {
      return this.$conf.visaService;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog.import-dialog {
  height: auto;
  max-height: 85vh;
  overflow-y: auto;
}
//弹出层里内容的高度
::v-deep .el-dialog__body {
  max-height: 85vh !important;
}

::v-deep .el-tabs__header {
  display: none;
}
::v-deep .el-steps {
  margin-bottom: 20px;
}
::v-deep .el-tabs__content {
  width: 94%;
  //   padding: 30px 40px 30px 20px;
}
::v-deep .el-step__icon.is-text {
  width: 40px;
  height: 40px;
}
::v-deep .el-step.is-horizontal .el-step__line {
  top: 19px;
  width: 266px;
  left: 67px;
}
.el-select {
  width: 90%;
}
.avatar {
  width: 70px;
  height: 54px;
}
.add-identity {
  .el-button {
    margin-left: 110px;
  }
}
.instruction-desc {
  .el-input {
    width: 500px;
  }
  .el-button--small {
    padding: 9px;
    margin: 0 5px;
  }
}
.border-wrap {
  border-bottom: 1px #666 solid;
  margin-bottom: 20px;
}
</style>